const map = {
	"./EULA-candidate.en.2020-10-21.md": 26073,
	"./EULA-candidate.en.2022-02-01.md": 50112,
	"./EULA-candidate.en.2023-12-06.md": 11765,
	"./EULA-candidate.en.2025-09-08.md": 86917,
	"./EULA-candidate.nb.2020-10-21.md": 15512,
	"./EULA-candidate.nb.2022-02-01.md": 80745,
	"./EULA-candidate.nb.2023-12-06.md": 73708,
	"./EULA-candidate.nb.2025-09-08.md": 24672
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26765;